import { render, staticRenderFns } from "./CourseDefinitionsTable.vue?vue&type=template&id=f175ddee"
import script from "./CourseDefinitionsTable.vue?vue&type=script&lang=js"
export * from "./CourseDefinitionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports